/**
 * Contact Form Frontend Logic
 */

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('osmerova-contact-form');

    if (!form) return;

    const statusDiv = form.querySelector('.form-status');
    const submitBtn = form.querySelector('button[type="submit"]');
    const messageTextarea = form.querySelector('#message');
    const radioInputs = form.querySelectorAll('input[name="subject_type"]');
    const nameInput = form.querySelector('#fullname');
    const phoneInput = form.querySelector("#phone");
    const emailInput = form.querySelector("#email");

    // --- Entrance Animation ---
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);

        const formWrapper = document.querySelector('.osmerova-contact-form-wrapper');

        if (formWrapper) {
            /* IMPLEMENTÁCIA BODU 5: Zjemnenie animácie (y: 30) */
            gsap.set(formWrapper, { autoAlpha: 0, y: 50 });

            gsap.to(formWrapper, {
                autoAlpha: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out",
                /* IMPLEMENTÁCIA BODU 5: Skrátenie delay na 0.3s */
                delay: 0.6,
                scrollTrigger: {
                    trigger: formWrapper,
                    start: "top 85%",
                    toggleActions: "play none none none"
                }
            });
        }
    }

    // --- Zvyšok logiky ponechaný bez zmeny podľa pôvodného kódu ---
    let iti = null;
    if (phoneInput && window.intlTelInput) {
        iti = window.intlTelInput(phoneInput, {
            preferredCountries: ['cz', 'sk'],
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.21/js/utils.js",
            separateDialCode: true,
            autoPlaceholder: "aggressive"
        });
    }

    const placeholders = {
        'objednavka': 'Dobrý den, chtěl(a) bych se objednat...',
        'dotaz': 'Dobrý den, rád(a) bych se zeptal(a) na...'
    };

    radioInputs.forEach(input => {
        input.addEventListener('change', (e) => {
            if (e.target.checked) {
                const type = e.target.value;
                if (placeholders[type]) {
                    messageTextarea.placeholder = placeholders[type];
                }
            }
        });
    });

    function validateForm() {
        let isValid = true;
        form.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));
        form.querySelectorAll('.error-message').forEach(el => el.textContent = '');

        // Kontrola mena (nové)
        const nameVal = nameInput.value.trim();
        if (!nameVal) {
            nameInput.classList.add('is-invalid');
            const errorMsg = nameInput.closest('.form-group').querySelector('.error-message');
            if (errorMsg) errorMsg.textContent = 'Prosím vyplňte své jméno';
            isValid = false;
        }

        // Kontrola telefónu (opravené hľadanie error-message cez closest)
        if (phoneInput.value.trim()) {
            if (iti && !iti.isValidNumber()) {
                phoneInput.classList.add('is-invalid');
                const errorMsg = phoneInput.closest('.form-group').querySelector('.error-message');
                if (errorMsg) errorMsg.textContent = 'Neplatný formát čísla';
                isValid = false;
            }
        }

        // Kontrola e-mailu (zachovaný pôvodný regex)
        const emailVal = emailInput.value.trim();
        if (!emailVal) {
            emailInput.classList.add('is-invalid');
            const errorMsg = emailInput.closest('.form-group').querySelector('.error-message');
            if (errorMsg) errorMsg.textContent = 'Prosím vyplňte svůj e-mail';
            isValid = false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailVal)) {
                emailInput.classList.add('is-invalid');
                const errorMsg = emailInput.closest('.form-group').querySelector('.error-message');
                if (errorMsg) errorMsg.textContent = 'Neplatný e-mail';
                isValid = false;
            }
        }

        // Kontrola správy (nové)
        const messageVal = messageTextarea.value.trim();
        if (!messageVal) {
            messageTextarea.classList.add('is-invalid');
            const errorMsg = messageTextarea.closest('.form-group').querySelector('.error-message');
            if (errorMsg) errorMsg.textContent = 'Prosím doplňte svou zprávu';
            isValid = false;
        }

        return isValid;
    }

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        statusDiv.textContent = '';
        statusDiv.className = 'form-status';

        if (!validateForm()) return;

        submitBtn.disabled = true;

        const fullname = form.querySelector('#fullname').value.trim();
        const email = emailInput.value.trim();
        const phone = (iti && iti.isValidNumber()) ? iti.getNumber() : phoneInput.value.trim();
        const message = form.querySelector('#message').value.trim();
        const subjectType = form.querySelector('input[name=\"subject_type\"]:checked').value;
        const recipientEmail = form.querySelector('input[name=\"recipient_email\"]')?.value || '';
        const honeypot = form.querySelector('input[name=\"osmerova_website_url\"]')?.value || '';
        const formLoadedAt = form.querySelector('input[name=\"form_loaded_at\"]')?.value || 0;

        if (!fullname) {
            showError('Prosím vyplňte své jméno.');
            submitBtn.disabled = false;
            return;
        }

        if (!email) {
            showError('Prosím vyplňte svůj e-mail.');
            submitBtn.disabled = false;
            return;
        }

        if (!message) {
            showError('Prosím doplňte svou zprávu.');
            submitBtn.disabled = false;
            return;
        }

        const formData = {
            fullname: fullname,
            email: email,
            phone: phone,
            message: message,
            subject_type: subjectType,
            recipient_email: recipientEmail,
            osmerova_website_url: honeypot,
            form_loaded_at: formLoadedAt,
            _wpnonce: osmerovaContactForm.nonce
        };

        try {
            const response = await fetch(osmerovaContactForm.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': osmerovaContactForm.nonce
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (response.ok) {
                showSuccess(result.message || 'Děkujeme, zpráva byla odeslána.');
                form.reset();
                messageTextarea.placeholder = placeholders['objednavka'];
            } else {
                if (response.status === 403) {
                    showError('Chyba zabezpečení. Obnovte prosím stránku.');
                } else if (response.status === 429) {
                    showError('Příliš mnoho pokusů. Zkuste to prosím za hodinu.');
                } else {
                    showError(result.message || 'Odeslání se nezdařilo.');
                }
            }
        } catch (error) {
            console.error('Error:', error);
            showError('Nastala chyba připojení.');
        } finally {
            submitBtn.disabled = false;
        }
    });

    function showError(msg) {
        statusDiv.textContent = msg;
        statusDiv.classList.add('error');
    }

    function showSuccess(msg) {
        statusDiv.textContent = msg;
        statusDiv.classList.add('success');
    }
});
